"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventAnalysts = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRequirements_1 = require("../CardRequirements");
var EventAnalysts = (function (_super) {
    __extends(EventAnalysts, _super);
    function EventAnalysts() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.EVENT_ANALYSTS,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 5,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.party(PartyName_1.PartyName.SCIENTISTS); }),
            metadata: {
                description: 'Requires that Scientists are ruling or that you have 2 delegates there.',
                cardNumber: 'T05',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.effect('You have +1 influence.', function (be) {
                    be.startEffect.influence(1);
                }); }),
            },
        }) || this;
    }
    EventAnalysts.prototype.play = function (player) {
        if (player.game.turmoil) {
            player.game.turmoil.addInfluenceBonus(player);
        }
        return undefined;
    };
    return EventAnalysts;
}(Card_1.Card));
exports.EventAnalysts = EventAnalysts;
//# sourceMappingURL=EventAnalysts.js.map